import React, { Component } from 'react'

import {
  Box, Button, Icon, Title, Subtitle
} from 'bloomer'

import {
  Droppable, Draggable
} from 'react-beautiful-dnd'

import Module from './Module'
import UpdateRoomModal from './modals/UpdateRoomModal'
import DeleteRoomModal from './modals/DeleteRoomModal'

const UPDATE_ROOM_MODAL = 'UPDATE_ROOM_MODAL'
const DELETE_ROOM_MODAL = 'DELETE_ROOM_MODAL'

export default class Room extends Component {
  state = {
    modalId: null
  }

  handleOpenModal = (modalId) => {
    this.setState(() => ({
      modalId
    }))
  }

  handleCloseModal = () => {
    this.setState(() => ({
      modalId: null
    }))
  }

  renderModal(Modal, id) {
    const { modalId } = this.state
    const { room, refetch } = this.props

    if (modalId !== id) {
      return null
    }

    return <Modal isActive={modalId === id} handleClose={this.handleCloseModal} room={room} refetch={refetch} />
  }

  render() {
    const { room, refetch, search } = this.props

    const modules = room.modules.filter(search)

    return (
      <React.Fragment>
        <Box>
          {room.modules.length === 0 && <Button isPulled="right" isSize="small" isColor="light" onClick={this.handleOpenModal.bind(this, DELETE_ROOM_MODAL)}>
            <Icon icon="trash-alt" />
          </Button>}
          <Button isPulled="right" isSize="small" isColor="light" onClick={this.handleOpenModal.bind(this, UPDATE_ROOM_MODAL)}>
            <Icon icon="pencil-alt" />
          </Button>
          <Title isSize={6} style={{textTransform: 'uppercase'}}>{room.name}</Title>
          <Droppable droppableId={room.id}>
            {(provided, snapshot) => (
              <div className="columns is-multiline" ref={provided.innerRef} style={{background: snapshot.isDraggingOver ? '#f5f5f5' : 'inherit', minHeight: '5em'}}>
                {modules.map((module, index) => (
                  <Draggable key={module.id} draggableId={module.id} index={index}>
                    {(provided, snapshot) => (
                      <div className="column is-12 is-half-widescreen" ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} style={{...provided.draggableProps.style}}>
                        <Module module={module} room={room} refetch={refetch} />
                      </div>
                    )}
                  </Draggable>
                ))}
                {(room.modules.length > 0 && modules.length === 0) && <div style={{opacity: .5, textAlign: 'center', padding: '1em', width: '100%'}}>
                  <Icon className="fa fa-times fa-3x" isSize="large" />
                  <Subtitle isSize={6}>Nenhum môdulo encontrado</Subtitle>
                </div>}
                {room.modules.length === 0 && <div style={{opacity: .5, textAlign: 'center', padding: '1em', width: '100%'}}>
                  <Icon className="fa fa-inbox fa-3x" isSize="large" />
                  <Subtitle isSize={6}>Cômodo vazio</Subtitle>
                </div>}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </Box>

        {this.renderModal(UpdateRoomModal, UPDATE_ROOM_MODAL)}
        {this.renderModal(DeleteRoomModal, DELETE_ROOM_MODAL)}
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/DashboardPage/Room.js